// eslint-disable-next-line no-undef
export const isSafari = () => /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
